import Listing from "./listing/index.js";
import Project from "./project/index.js";
import Land_Sale from "./land_sale/index.js";
import Mortgage from "./mortgage/index.js";

// import Hook from "config/hook/search-form/akvkxwyx.elementor.cloud/index.js";

const getDomain = () => {
  const domain = window.location.hostname;
  return (domain === "localhost" ? "res.rocksolid.sg" : domain);
  // return (domain === "localhost" ? "akvkxwyx.elementor.cloud" : domain);
}

const getPostTypeAPI = ({ post_type }) => {
  const domain = getDomain();
  return `https://${domain}/wp-json/wp/v2/${post_type}`;
}

const getConfig = ({ post_type, search_type, fullscreen, spinner }) => {

  const ALL_POST_TYPES = [
    Listing,
    Project,
    Land_Sale,
    Mortgage,
  ];

  const {
    getSearchFields, getSearchFormConfig,
    getSearchResultCol, getSearchResultCard, getSearchResultColProps, getSearchResultCardProps, getSearchResultMapFeatureProps,
    getSearchParams, getSearchParamsHook, getSearchResultsHook,
  } = ALL_POST_TYPES.find(item => item.getId() === post_type);

  const wp_api = getPostTypeAPI({ post_type });

  const CONFIG = {
    //
    domain: getDomain(),
    post_type,
    search_type,
    fullscreen,
    spinner,
    //
    SEARCH_PARAMS: { url: wp_api, ...getSearchParams({ search_type }) },
    SEARCH_PARAMS_HOOK: getSearchParamsHook(),
    SEARCH_RESULTS_HOOK: getSearchResultsHook(),
    //
    GET_SEARCH_FIELDS: getSearchFields,
    GET_SEARCH_FORM_CONFIG: getSearchFormConfig,
    GET_SEARCH_RESULT_COL: getSearchResultCol,
    GET_SEARCH_RESULT_CARD: getSearchResultCard,
    //
    GET_SEARCH_RESULT_COL_PROPS: getSearchResultColProps,
    GET_SEARCH_RESULT_CARD_PROPS: getSearchResultCardProps,
    GET_SEARCH_RESULT_MAP_FEATURE_PROPS: getSearchResultMapFeatureProps,
    //
  }

  const hookName = `ROCKSOLID_CUSTOM_SEARCH_CONFIG_HOOK_${post_type.toUpperCase()}`;
  return {
    ...CONFIG,
    ...window?.[hookName]?.(CONFIG),
  }

}

export {
  getDomain,
  getConfig,
}
